import img1 from '../images/slider/Furore.png';
import img2 from '../images/slider/icon_1.png';
import img3 from '../images/slider/icon_2.png';
import img4 from '../images/slider/icon_3.png';

const dataBanner = [
    {
        id: 0,
        heading: '',
        heading1: '',
        sub_heading: '',
        img: '../images/backgroup/bg_00.png',
        className: 'slider-st1 banner_bg0'
    },
    {
        id: 1,
        heading: '德联品质 · 始终如一',
        heading1: '众多汽车品牌的原厂配套专家',
        sub_heading: '上海德联车护网络发展有限公司是德联集团旗下企业。通过创新型MB2B2C平台，为广大车主提供高品质、高性价比的原厂配套汽车养护服务。通过“德联2S”运营网络，致力于推动中国汽车后市场专业服务连锁业态的发展，最大程度的实现渠道合作方共赢，提升终端客户满意度。旨在打造中国汽车后市场服务领域的优秀民族品牌，传播“品质、专业、责任、分享”的品牌价值观。',
        img: '../images/backgroup/bg_01.png',
        className:'slider-st1 banner_bg1'
    }, 
    {
        id: 2,
        heading: '高效服务 · 全程陪伴',
        heading1: '全方位的支持服务',
        sub_heading: '全方位的支持服务是德联的核心优势之一。我们不仅提供产品供应链服务，确保产品的高效流通；与多家银行紧密合作，帮助服务商解决资金周转问题。同时，德联提供的IT服务和增值服务，可以帮助汽车门店实现信息化管理，通过抖音平台的数据分析，精准给出用户画像和科学化的决策。德联的专业团队将始终陪伴在您身边，提供全方位的支持服务，让您的业务发展如虎添翼。',
        img: '../images/backgroup/bg_02.png',
        className: 'slider-st1 banner_bg2'
    }
]

export default dataBanner;